import {createAction} from '@reduxjs/toolkit'
import {RIBBON} from '../../../../commons/constants/ribbons'
import {EVENT_BADGE} from '../../../../settings-commons/components/event-badges/interfaces'

export const openListLayoutItem = createAction<string>('OPEN_LIST_LAYOUT_ITEM')

export const closeListLayoutItems = createAction('CLOSE_LIST_LAYOUT_ITEMS')

export const widgetLoaded = createAction<boolean>('WIDGET_LOADED')

export const showRibbons = createAction<RIBBON>('SHOW_RIBBONS')

export const hideRibbons = createAction('HIDE_RIBBONS')

export const showEventBadge = createAction<EVENT_BADGE>('SHOW_EVENT_BADGE')

export const hideEventBadge = createAction('HIDE_EVENT_BADGE')
